import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=1c5c3c22&scoped=true&"
import script from "./deals.vue?vue&type=script&lang=js&"
export * from "./deals.vue?vue&type=script&lang=js&"
import style0 from "./deals.vue?vue&type=style&index=0&id=1c5c3c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c3c22",
  null
  
)

export default component.exports